<!--
 * @Description: 外部账号导入
 * @Author: liuwp
 * @Date: 2022-09-23 16:40:06
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-29 17:15:49
-->
<template>
  <section>
    <yxt-drawer
      :destroy-on-close="true"
      size="640px"
      :title="$t('pc_ac_lbl_import_outer').d('外部账号导入')"
      :visible.sync="showVisitorDrawer"
      :close-on-press-escape="false"
      @close='closeDrawer'
    >
      <yxtbiz-visitor-importor @getUserList="getUserList"></yxtbiz-visitor-importor>
      <div slot="footer">
        <yxt-button @click="closeDrawer">
          {{ $t('pc_ac_btn_cancel').d('取消') }}
        </yxt-button>
        <yxt-button
          type="primary"
          @click="submit"
        >
          {{ $t('pc_ac_btn_sure').d('确定') }}
        </yxt-button>
      </div>
    </yxt-drawer>
  </section>
</template>
<script>
import { addExternalerApi } from '../service';
export default {
  props: ['showVisitorDrawer', 'activityId'],
  data() {
    return {
      ids: []
    };
  },
  methods: {
    closeDrawer() {
      this.$emit('closeDrawer');
    },
    submit() {
      if (!this.ids.length) return;
      addExternalerApi(this.activityId, {
        userIds: this.ids
      }).then(v => {
        this.$emit('submited');
        this.closeDrawer();
      });
    },
    getUserList(res) {
      this.ids = res.data.map(item => item.id);
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
